import { AgendaModel } from "./../../models/agenda.model";
import { VisitaModel } from "./../../models/visita.model";
import { ModalRegistrarVisitaComponent } from "./registrar-visita-modal.component";
import { ConfirmationModalOptions } from "./../../shared/models/modal.model";
import { GlobalService } from "../../shared/global.service";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgbModal, NgbModalRef, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { UrlService } from "../../shared/services/url.service";
import { UrlControl } from "../../shared/models/generic.model";
import { AlertService } from "../../shared/services/alert.service";
import { FormGroup } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FuncionarioModel,
  FuncionarioBasicoModel,
} from "src/app/models/funcionario.model";
import { ConstantesService } from "src/app/shared/services/constantes.service";
import { ISubscription, Subscription } from "rxjs/Subscription";
import { DominiosService } from "src/app/shared/services/dominios.service";
import { UtilService } from "src/app/shared/services/util.service";
import * as moment from "moment";
import { VariablesZonaCompartida } from "src/app/shared/services/VariablesZonaCompartida";

declare var $: any;

@Component({
  selector: "app-formulario-registrar-visita",
  templateUrl: "./formulario-registrar-visita.component.html",
  styleUrls: ["./formulario-regisrar-visita.component.scss"],
})
export class FormularioRegistrarVisitaComponent implements OnInit, OnDestroy {

  isOpen = false;

  private subscription: Subscription[];
  public correoInvalido: boolean;
  public numeroDocumentoInvalido: boolean;
  closeResult: string;
  modal: NgbModalRef;
  options: any;
  public calendarioRange = false;
  public visitaModel: AgendaModel;
  public listadoTipoDocumento;
  public listadoMotivoIngresoComo;
  public listadoRh;
  public formularioVisita: FormGroup;
  public listadoTipoVehiculo;
  public listadoTipoVehiculo1;
  public vehiculo: number;
  public agendas: any;
  public objetoAgendaConsulta: any;
  public fechaMin: any;
  public fechaMax: any;
  public editar: boolean;
  public consultaInformacionVisitante: AgendaModel;
  public modalOptions: ConfirmationModalOptions;
  public modalOptionsEditar: ConfirmationModalOptions;
  public formDisabled: boolean;
  public placaInvalida: boolean;
  public inhabilitarCampos;
  public documentoPreatorizador: any;
  public tipoDocPreautorizador: any;
  public preautorizadorDiferente: boolean;
  public estadoNoEditable: boolean;
  private horaInicioEdicion: string;
  private horaFinEdicion: string;
  public disableDatePicker: boolean;
  private noPrograma = "No programada";
  public nombresVisitante: string;
  public apellidosVisitante: string;
  public agendaMensaje: boolean;
  public repetirAgenda = false;
  public fechaFinAgenda: Date;
  public fechaConsulta: Date;
  public fechaMinFin: Date;

  public descripcionOtro = "";

  constructor(
    public modalService: NgbModal,
    private global: GlobalService,
    private urlService: UrlService,
    private alertService: AlertService,
    private utilService: UtilService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    let mensajeConfirmacionAgenda = "¿Está seguro de registrar visita?";
    this.subscription = [];
    this.disableDatePicker = false;
    this.formDisabled = true;
    this.placaInvalida = false;
    this.preautorizadorDiferente = false;
    this.documentoPreatorizador = sessionStorage.getItem("numDocumento");
    this.tipoDocPreautorizador = sessionStorage.getItem("tipoDocumento");
    this.inhabilitarCampos = false;
    this.correoInvalido = false;
	this.numeroDocumentoInvalido = false;
    this.listadoTipoDocumento = [];
	this.listadoMotivoIngresoComo = [];
	this.listadoRh = [];
    this.listadoTipoVehiculo = [];
    this.listadoTipoVehiculo1 = [];
    this.visitaModel = new AgendaModel(null, null, null, null, null, []);
    // fromero 20/05/2019
    // obtiene el objeto que viene de editar agenda
    const ObjetoEntrante =
      this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA];

    this.modalOptions = new ConfirmationModalOptions(
      "Confirmación",
      mensajeConfirmacionAgenda,
      "SI",
      "NO",
      "far fa-calendar",
      this.formDisabled,
      false,
      "Registrar Visita",
      null,
      "btn-secondary"
    );

    // fromero 2015/2019
    // Valida si viene un objeto desde editar Agenda o si es una nueva agenda
    if (ObjetoEntrante) {
      // tslint:disable-next-line: triple-equals
      if (ObjetoEntrante.agendaVisita != this.noPrograma) {
        this.editar = true;
        mensajeConfirmacionAgenda =
          "¿Está Seguro de Guardar la Ediciòn de la Agenda?";
        this.modalOptions.buttonName = "Guardar Edición";
        this.objetoAgendaConsulta = ObjetoEntrante;

        // tslint:disable: triple-equals
        if (
          this.objetoAgendaConsulta.numeroIdQuienAutoriza !=
            this.documentoPreatorizador ||
          this.objetoAgendaConsulta.tipoIdQuienAutoriza !=
            this.tipoDocPreautorizador
        ) {
          this.preautorizadorDiferente = true;
        }
        if (this.objetoAgendaConsulta.estadoAgenda != "AGENDADA") {
          this.estadoNoEditable = true;
        } else {
          this.estadoNoEditable = false;
        }

        // se construye la fecha
        if (this.objetoAgendaConsulta.agendaVisita) {
          const hinicio = this.objetoAgendaConsulta.agendaVisita.split(" ")[1];
          const hfin = this.objetoAgendaConsulta.agendaVisita.split(" ")[3];
          const fechaTexto =
            this.objetoAgendaConsulta.agendaVisita.split(" ")[0];
          this.fechaConsulta = moment(fechaTexto, "DD/MM/YYYY").toDate();
          this.convertirHorasAgendaEdicion(hinicio, hfin, fechaTexto);
        }

        if (ObjetoEntrante.tipoVisitante == "FUNC") {
          this.inhabilitarCampos = true;
        }
      } else {
        this.editar = false;
        this.fechaConsulta = new Date();
        this.fechaMin = new Date();
        this.disableDatePicker = true;
        this.visitaModel.numeroDocumentoUsuario =
          ObjetoEntrante.numeroIdVisitante;
        this.visitaModel.tipoDocumentoUsuario = ObjetoEntrante.tipoIdVisitante;
        this.obtenerFuncionario(ObjetoEntrante.numeroIdVisitante);
      }
    } else {
      this.editar = false;
      this.fechaConsulta = new Date();
      this.fechaMin = new Date();
      this.disableDatePicker = true;
    }
  }

  ngOnInit() {
    this.getTipoIdentificacion();
	this.getMotivoIngresoComo();
	this.getRh();
    this.obtenerTipoVehiculo();
  }

  /**
   * @author fromero
   * @param horai
   * @param horaf
   */
  convertirHorasAgendaEdicion(horai, horaf, fecha) {
    let h = null;
    if (horai.split("").includes("p")) {
      h = horai.split("");
      // tslint:disable: radix
      this.horaInicioEdicion =
        (parseInt(h[0]) + parseInt(h[1]) + 12).toString() + ":00";
    } else {
      h = horai.replace("am", "");
      this.horaInicioEdicion = h;
    }

    if (horaf.split("").includes("p")) {
      h = horaf.split("");
      this.horaFinEdicion =
        (parseInt(h[0]) + parseInt(h[1]) + 12).toString() + ":00";
    } else {
      h = horaf.replace("am", "");
      this.horaFinEdicion = h;
    }

    this.consultarAgendasEdicion(fecha);
  }

  /**
   * consulta de Agendas para edición
   * @author fromero
   * 28/05/2019
   */
  consultarAgendasEdicion(fecha) {
    this.spinner.show();
    const serviceProvider = "ObetenerInformacionAgendasVisitante";
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push([
      "tipoDocumento",
      this.objetoAgendaConsulta.tipoIdVisitante,
    ]);
    queryParams.push([
      "numeroDocumento",
      this.objetoAgendaConsulta.numeroIdVisitante,
    ]);
    queryParams.push(["fechaConsulta", fecha]);

    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_ACCVIS
    );

    const sunscribe = this.global.postGenerico(url).subscribe(
      (data) => {
        if (data.length > 0) {
          const obj: any = data[0];
          this.consultaInformacionVisitante = obj;
          this.visitaModel.correo = obj.correoElectronico;
          this.visitaModel.tipoDocumentoUsuario = obj.tipoDocumento;
          if (obj.listaVisitas && obj.listaVisitas.length > 0) {
            if (obj.listaVisitas[0].num_Doc_Visitante) {
              this.visitaModel.numeroDocumentoUsuario =
                obj.listaVisitas[0].num_Doc_Visitante;
            }

            const arrayTemp = obj.listaVisitas;
            this.visitaModel.visitas = [];
            arrayTemp.forEach((element) => {
              const c =
                element.fecha_Inicial_Agendada.split(" ")[0] +
                " " +
                element.horaFinalAgendada +
                ":00";

              const agendaTemp = new VisitaModel(
                element.fecha_Inicial_Agendada,
                element.fecha_Inicial_Agendada,
                c,
                element.dependencia,
                new FuncionarioModel(
                  element.numero_Id_Funcionario,
                  element.tipo_Id_Funcionario
                ),
                false,
                obj.nombreCompleto,
                this.objetoAgendaConsulta.tipoIdVisitante,
                element.num_Doc_Visitante,
                "CAN",
                null,
                null,
                c,
                element.idDependencia,
                false,
                obj.primerNombre,
                obj.segundoNombre,
                obj.primerApellido,
                obj.segundoApellido,
				
				obj.tipoVisita
              );
              // if (agendaTemp.fechaInicioAgendada.split(' ')[1] == this.horaInicioEdicion + ':00') {
              this.visitaModel.visitas.push(agendaTemp);
              this.visitaModel.placa = element.placa;
              this.visitaModel.tipoVehiculo = element.tipoVehiculo;
              this.visitaModel.otro = element.otro;
              this.descripcionOtro = element.otro;
			  
              this.visitaModel.telefono = obj.telefono;
              this.visitaModel.motivoIngresoComo = obj.motivoIngresoComo;
              this.visitaModel.rh = obj.rh;
              this.visitaModel.eps = obj.eps;
              this.visitaModel.arl = obj.arl;
              this.visitaModel.nombreContactoEmergencia = obj.nombreContactoEmergencia;
              this.visitaModel.telefonoContactoEmergencia = obj.telefonoContactoEmergencia;
              this.visitaModel.alergiasMedicamentos = obj.alergiasMedicamentos;
			
              //  }
            });
          }
          this.visitaModel.nombreUsuario = obj.nombreCompleto;
          this.visitaModel.primerNombre = obj.primerNombre;
          this.visitaModel.segundoNombre = obj.segundoNombre;
          this.visitaModel.primerApellido = obj.primerApellido;
          this.visitaModel.segundoApellido = obj.segundoApellido;
          this.nombresVisitante =
            obj.primerNombre +
            (obj.segundoNombre ? " " + obj.segundoNombre : "");
          this.apellidosVisitante =
            obj.primerApellido +
            (obj.segundoApellido ? " " + obj.segundoApellido : "");
          this.visitaModel.empresa = obj.empresa;
          // this.visitaModel.placa = obj.placa;
          this.visitaModel.tipoDocumentoUsuario =
            this.objetoAgendaConsulta.tipoIdVisitante;
          this.visitaModel.tipoVisita = obj.tipoVisita;
          this.visitaModel.numeroDocumentoUsuario = obj.numeroDocumento;
          //   if (obj.vehiculo) {
          //    this.visitaModel.tipoVehiculo = obj.vehiculo;

          this.consultaInformacionVisitante = this.visitaModel;

          if (obj.funcionario == true) {
            this.visitaModel.tipoVisitante =
              DominiosService.DOMINIO_TIPO_VISITANTE;
          }
		  
		  

          setTimeout(() => {
            // this.getTipoVehiculo(this.visitaModel.tipoVehiculo);
            this.iniciarBotonesVehiculo(obj.vehiculo);
            // this.spinner.hide();
          }, 1000);
          // } else {
          this.spinner.hide();
          // }
        } else {
          this.spinner.hide();
        }
      },
      (err) => {
        this.cathException(err);
      }
    );
    this.subscription.push(sunscribe);
  }

  /**
   *
   */
  onSubmit() {
    if (this.editar) {
      //this.convertirHora(this.visitaModel.visitas);
    }
    this.guardarAgenda(this.visitaModel);
  }

  convertirHora(agendas: VisitaModel[]) {
    agendas.forEach((element) => {
      element.nuevaAgenda = false;
      const hora = element.fechaInicioAgendada.split(" ");
      if (hora.length > 1) {
        const h = hora[1].split(":");
        if (h.length > 2) {
          element.horaInicioVisita = h[0] + ":" + h[1];
        } else {
          element.horaInicioVisita = hora[1];
        }
      }
      const hora2 = element.fechaFinAgendada.split(" ");
      if (hora2.length > 1) {
        const h = hora2[1].split(":");
        if (h.length > 2) {
          element.horaFinVisita = h[0] + ":" + h[1];
        } else {
          element.horaFinVisita = hora[1];
        }
      }
    });
  }

  /**
   * @author fromero
   * metodo que construye la fecha que se envia al modal en la ediciòn
   *
   */
  setDateEdit() {
    this.visitaModel.fechaInicioAgendada =
      this.utilService.convertirDatetoString(this.fechaConsulta);
    this.vermodal();
  }

  /**
   * @author fromero
   * llama al modal de detalle de agenda y
   *  crea un observable que espera el objeto respuesta
   */
  public vermodal() {
    const modalRef = this.modalService.open(ModalRegistrarVisitaComponent, {
      centered: false,
      size: "lg",
    });

    if (this.editar) {
      this.visitaModel.editar = true;
    }

    modalRef.componentInstance.data = this.visitaModel; // Objeto que se envìa al modal para ediciòn
    modalRef.componentInstance.consultaInformacionVisitante =
      this.consultaInformacionVisitante;
    modalRef.result.then((result) => {
      this.visitaModel.visitas = result.listaVisitas;
      this.validarFormulario();
    });
  }

  /** fromero:
   * método Para capturar la respuesta que viene del modal, se devuelven un boolean con la respuesta
   * y el objeto enviado en caso de que se modifique
   * @param event
   */
  getConfirmationModalResponse(event) {
    if (event[0] === true) {
      this.onSubmit();
    }
  }

  /**
   * fromero
   * obtiene la fecha seleccionada en el datepicker
   * @param event
   */
  public handlerDatePickeR(event) {
    this.fechaConsulta = event;
    if (this.fechaConsulta != event) {
      this.visitaModel.visitas = [];
    }
    if (event) {
      this.visitaModel.fechaInicioAgendada =
        this.utilService.convertirDatetoString(event);
      this.vermodal();
    } else if (this.repetirAgenda) {
      this.fechaFinAgenda = undefined;
      this.visitaModel.fechaInicioAgendada = undefined;
      this.repetirAgenda = false;
      this.visitaModel.visitas = [];
    } else {
      this.fechaConsulta = new Date();
      this.visitaModel.visitas = [];
    }
  }

  /**
   * obtiene la fecha fin agenda multiple
   * @param event
   */
  public actualizarFechaFinAgenda(event: Date) {
    if (!event || event.getTime() < this.fechaConsulta.getTime()) {
      this.alertService.generateAlertError(
        "La fecha de fin no puede ser mayor a la fecha de la agenda",
        ""
      );
      this.fechaFinAgenda = undefined;
    } else {
      this.fechaFinAgenda = event;
    }
  }

  /**
   * obtiene el dominio tipo identificacion
   * jvillalobos
   */
  public getTipoIdentificacion() {
    const serviceProvider = "getTipoIdentificacion";
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_ACCVIS
    );
    const sucripcion = this.global.getGenerico(url).subscribe(
      (data) => {
        this.listadoTipoDocumento = data;
      },
      (err) => {
        this.cathException("Error Consultando el Dominio");
      }
    );
    this.subscription.push(sucripcion);
  }
  
    public getMotivoIngresoComo() {
		const serviceProvider = "getMotivoIngresoComo";
		const url = this.urlService.getUrl(
		  new UrlControl(serviceProvider, null, null),
		  this.urlService.hostAPI_ACCVIS
		);
		const sucripcion = this.global.getGenerico(url).subscribe(
		  (data) => {
			this.listadoMotivoIngresoComo = data;
		  },
		  (err) => {
			this.cathException("Error Consultando el Dominio");
		  }
		);
		this.subscription.push(sucripcion);
	  }
	  
	public getRh(){
		this.getDetalleDominio( this.listadoRh, "getRh" );		
	}
	 
	 public getDetalleDominio( objetoDestino: any, serviceProvider: string ) {
		const url = this.urlService.getUrl(
		  new UrlControl(serviceProvider, null, null),
		  this.urlService.hostAPI_ACCVIS
		);
		const sucripcion = this.global.getGenerico(url).subscribe(
		  (data) => {
			Object.keys(data).map(function(key){  
				objetoDestino.push(data[key])  
				return objetoDestino;  
			});
		  },
		  (err) => {
			this.cathException("Error Consultando el Dominio");
		  }
		);
		this.subscription.push(sucripcion);
	  }


  /**
   *
   * @param error
   */
  cathException(error) {
    this.alertService.generateAlertError(error, "Error");
    this.spinner.hide();
  }

  /**
   * jvillalobos
   * obtiene los tipos de vehiculo
   */
  public obtenerTipoVehiculo() {
    this.spinner.show();
    const serviceProvider = "ObtenerTipoVehiculo";
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, null),
      this.urlService.hostAPI_ACCVIS
    );
    const subscribe = this.global.getGenerico(url).subscribe(
      (data) => {
        this.listadoTipoVehiculo = data;
        this.listadoTipoVehiculo.forEach((element) => {
          const i = this.listadoTipoVehiculo.indexOf(element);
          // if (element.valor === 'No') {
          //   this.listadoTipoVehiculo.splice(i);
          // }
        });
        // data = data.pop();
        this.spinner.hide();
      },
      (err) => {
        this.cathException("Error consultando el dominio");
      }
    );
    this.subscription.push(subscribe);
  }

  /**
   * fromero
   * 15/07/2019
   * Validacion de tipo de registro de agenda
   * @param agenda
   */
  public guardarAgenda(agenda: AgendaModel) {
    this.spinner.show();

    if (
      this.repetirAgenda &&
      this.fechaConsulta.getTime() > this.fechaFinAgenda.getTime()
    ) {
      this.alertService.generateAlertError(
        ConstantesService.MSG_AGENDA_FECHAS_MULTIPLE_ERROR,
        "Error"
      );
      this.spinner.hide();
      return;
    }

    let tipoRegistro = null;
    if (this.editar) {
      tipoRegistro = "edicion";
      agenda.numeroDocumentoUsuarioAnterior =
        this.objetoAgendaConsulta.numeroIdVisitante;
      agenda.tipoDocumentoUsuarioAnterior =
        this.objetoAgendaConsulta.tipoIdVisitante;
      agenda.visitas.forEach((visita) => {
        visita.tipoDocumentoVisitante = this.visitaModel.tipoDocumentoUsuario;
        visita.numeroDocumentoVisitante =
          this.visitaModel.numeroDocumentoUsuario;
        visita.nombreVisitante = this.visitaModel.nombreUsuario;
        visita.primerNombre = this.visitaModel.primerNombre;
        visita.segundoNombre = this.visitaModel.segundoNombre;
        visita.primerApellido = this.visitaModel.primerApellido;
        visita.segundoApellido = this.visitaModel.segundoApellido;
        visita.tipoVisita = this.visitaModel.tipoVisita;
      });
    } else {
      tipoRegistro = "guardar";
    }
    if (this.preautorizadorDiferente) {
      this.alertService.generateAlertError(
        ConstantesService.MSG_AGENDA_CREADA_POR_OTRO_PREAUT,
        "Error"
      );
      this.spinner.hide();
    } else {
      if (this.estadoNoEditable) {
        this.alertService.generateAlertError(
          ConstantesService.MSG_AGENDA_ESTADO_NO_EDITABLE,
          "Error"
        );
        this.spinner.hide();
      } else {
        this.peticionGuardarEditarAgenda(agenda, tipoRegistro);
      }
    }
  }

  /**
   * fromero
   * 15/07/2019
   * petición a servicio de registro de agenda
   * @param agenda
   * @param tipoRegistro
   */
  private peticionGuardarEditarAgenda(agenda: AgendaModel, tipoRegistro) {
    const serviceProvider = "GuardarAgendaVisitante";
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(["tipoRegistro", tipoRegistro]);
    if (!this.repetirAgenda) {
      this.fechaFinAgenda = undefined;
    }
    queryParams.push([
      "fechaRepetirAgenda",
      this.fechaFinAgenda
        ? this.utilService.convertirDatetoString(this.fechaFinAgenda)
        : "",
    ]);

    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_ACCVIS
    );
    agenda.numeroDocumentoUsuarioAutorizador =
      sessionStorage.getItem("numDocumento");
    agenda.tipoDocumentoUsuarioAutorizador =
      sessionStorage.getItem("tipoDocumento");

    if (
      !agenda.numeroDocumentoUsuarioAutorizador ||
      !agenda.tipoDocumentoUsuarioAutorizador
    ) {
      this.alertService.generateAlertError(
        "No existen datos del preautorizador, vuelva a inicar sesión",
        ""
      );
    } else {
      const subscribe = this.global.postGenerico(url, agenda).subscribe(
        (data) => {
          this.spinner.hide();
          if (this.editar) {
            this.alertService.generateAlertSuccess(
              ConstantesService.MSG_ACTUALIZACION_AGND_CORRECTA,
              ""
            );
          } else {
            this.alertService.generateAlertSuccess(
              ConstantesService.MSG_AGENDA_CREADA_EXITO,
              ""
            );
            if (agenda.tipoVehiculo != null) {
              this.alertService.generateAlertSuccess(
                ConstantesService.MSG_PARQUEADERO_VERIFICACION,
                ""
              );
            }
          }
          this.regresarListaAgendas();
        },
        (err) => {
          this.cathException(err.error.message);
          // this.cathException('No es posible crear la agenda');
        }
      );
      this.subscription.push(subscribe);
    }
  }

  /**
   * fromero
   * 15/07/2019
   *
   * @param valor
   */
  public iniciarBotonesVehiculo(valor) {
    this.spinner.show();
    this.vehiculo = valor;
    const idvehiculo = "btn-" + valor;
    const b = document.getElementById(idvehiculo);
    if (b) {
      if (document.getElementById(idvehiculo)) {
        document.getElementById(idvehiculo).classList.add("selected");
      }
      this.validarFormulario(idvehiculo);
    } else {
      this.validarFormulario();
      this.spinner.hide();
    }
  }

  /**
   * fromero
   *  15/07/2019
   * método que realiza la petición con los datos de guardado
   * @param valor
   */
  public getTipoVehiculo(valor: any) {
    this.vehiculo = valor;
    const idvehiculo = "btn-" + valor;
    const b = document.getElementById(idvehiculo);

    if (idvehiculo == ConstantesService.BTN_OTRO) {
      this.visitaModel.placa = "";
      this.visitaModel.tipoVehiculo = valor;
      $(".tipovehiculo").removeClass("selected");
      b.classList.add("selected");
      this.validarFormulario(idvehiculo);
      this.isOpen = true;
    } else {
      if (b && this.visitaModel.tipoVehiculo !== valor) {
        this.visitaModel.placa = "";
        this.visitaModel.tipoVehiculo = valor;
        $(".tipovehiculo").removeClass("selected");
        b.classList.add("selected");
        this.validarFormulario(idvehiculo);
      }
    }
  }

  /*
  */
  closeOverlay() {
    this.isOpen = false;
    this.descripcionOtro = this.visitaModel.otro;
  }

  guardarOtro() {
    this.isOpen = false;
    this.visitaModel.otro = this.descripcionOtro;
  }

  /**
   * consulta obtener agenda
   */
  obtenerAgenda() {
    this.spinner.show();
    const serviceProvider = "ObtenerAgendaVisitante";
    const pathParams: Array<[number, string]> = null;
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push([
      "agendaPK.numDocVisitante",
      this.urlService.encodeURI(this.visitaModel.numeroDocumentoUsuario),
    ]);
    const url = this.urlService.getUrl(
      new UrlControl(serviceProvider, null, queryParams),
      this.urlService.hostAPI_ACCVIS
    );

    const subscribe = this.global.getGenerico(url).subscribe(
      (data) => {
        this.agendas = data;
      },
      (err) => {
        this.cathException(err);
      }
    );
    this.subscription.push(subscribe);
  }
  
  limpiarVisitaModel(){
  
	this.visitaModel = new AgendaModel(
		"",
		"",
		"",
		this.visitaModel.numeroDocumentoUsuario, 
		this.visitaModel.tipoDocumentoUsuario,		
		this.visitaModel.visitas
	  );

	this.visitaModel.correo = null;
	this.visitaModel.empresa = null;
	this.visitaModel.nombreUsuario = null;
	this.visitaModel.primerNombre = null;
	this.visitaModel.segundoNombre = null;
	this.visitaModel.primerApellido = null;
	this.visitaModel.segundoApellido = null;

	this.visitaModel.alergiasMedicamentos = null;
	this.visitaModel.arl = null;
	this.visitaModel.eps = null;	
	this.visitaModel.nombreContactoEmergencia = null;
	this.visitaModel.rh = null;			  
	this.visitaModel.telefono = null;
	this.visitaModel.telefonoContactoEmergencia = null;
	
	this.procesarNombre();
  }

  /**
   * fromero
   * consulta obtener documento
   * @param numerodocumento
   */
  obtenerVisitante(numerodocumento: string) {
    if (
      numerodocumento.length >= 1 &&
      this.visitaModel.tipoDocumentoUsuario &&
      this.visitaModel.tipoDocumentoUsuario !== ""
    ) {
      this.spinner.show();
      const serviceProvider = "ObtenerVisitante";
      const pathParams: Array<[string, string]> = new Array<[string, string]>();

      pathParams.push([
        "filterBy=visitantePK.numDocVisitante",
        this.urlService.encodeURI(numerodocumento),
      ]);
      pathParams.push([
        "visitantePK.tipoDocVisitante",
        this.urlService.encodeURI(this.visitaModel.tipoDocumentoUsuario),
      ]);

      const url = this.urlService.getUrl(
        new UrlControl(serviceProvider, pathParams, null),
        this.urlService.hostAPI_ACCVIS
      );

      const subscribe = this.global.getGenerico(url).subscribe(
        (data) => {
          if (data.length > 0) {
            const visitante = data[0];

            if (visitante) {
              this.visitaModel.correo = visitante.correoVisitante;
              this.visitaModel.empresa = visitante.empresa;
              this.visitaModel.nombreUsuario = visitante.nombreCompleto;
              this.visitaModel.primerNombre = visitante.primerNombre;
              this.visitaModel.segundoNombre = visitante.segundoNombre;
              this.visitaModel.primerApellido = visitante.primerApellido;
              this.visitaModel.segundoApellido = visitante.segundoApellido;
              this.visitaModel.numeroDocumentoUsuario =
                visitante.visitantePK.numDocVisitante;
              this.visitaModel.tipoDocumentoUsuario =
                visitante.visitantePK.tipoDocVisitante;
              this.visitaModel.tipoVisitante = visitante.tipoVisitante;
			  
			  this.visitaModel.alergiasMedicamentos = visitante.alergiasMedicamentos;
			  this.visitaModel.arl = visitante.arl;
			  this.visitaModel.eps = visitante.eps;			  
			  this.visitaModel.nombreContactoEmergencia = visitante.nombreContactoEmergencia;
			  this.visitaModel.rh = visitante.rh;			  
			  this.visitaModel.telefono = visitante.telefono;
			  this.visitaModel.telefonoContactoEmergencia = visitante.telefonoContactoEmergencia;			  
			  
              this.procesarNombre();
              
            } else {
              this.limpiarVisitaModel();
            }            
          } else {
            this.limpiarVisitaModel();
          }
		  this.visitaModel.visitas = [];
          this.disableDatePicker = false;
          this.spinner.hide();
		  this.fechaConsulta = !this.fechaConsulta
              ? new Date()
              : this.fechaConsulta;
        },
        (err) => {
          this.cathException("Error al obtener visitante");
          this.disableDatePicker = false;
        }
      );
      this.subscription.push(subscribe);
    }
  }

  private procesarNombre() {
    this.nombresVisitante =
      (this.visitaModel.primerNombre ? this.visitaModel.primerNombre : "") +
      (this.visitaModel.segundoNombre
        ? " " + this.visitaModel.segundoNombre
        : "");
    this.apellidosVisitante =
      (this.visitaModel.primerApellido ? this.visitaModel.primerApellido : "") +
      (this.visitaModel.segundoApellido
        ? " " + this.visitaModel.segundoApellido
        : "");
  }

  /**
   * fromero
   * consulta obtener funcionario
   * @param numerodocumento
   */
  obtenerFuncionario(numerodocumento) {
    if (
      numerodocumento.length >= 1 &&
      this.visitaModel.tipoDocumentoUsuario &&
      this.visitaModel.tipoDocumentoUsuario != ""
    ) {
      this.spinner.show();
      const serviceProvider = "consultarFuncionarioAgenda";
      const queryParams: Array<[string, string]> = new Array<
        [string, string]
      >();
      queryParams.push([
        "tipoIdFuncionario",
        this.visitaModel.tipoDocumentoUsuario,
      ]);
      queryParams.push(["numIdFuncionario", numerodocumento]);
      const url = this.urlService.getUrl(
        new UrlControl(serviceProvider, null, queryParams),
        this.urlService.hostAPI_ACCVIS
      );

      const subscribe = this.global.getGenerico(url).subscribe(
        (data) => {
          if (data.length > 0) {
            const funcionario = data[0];			
			this.limpiarVisitaModel();
			
            if (funcionario) {              
              this.visitaModel.correo = funcionario.correo;
              this.visitaModel.empresa = "MINISTERIO DE EDUCACIÓN";
              this.visitaModel.nombreUsuario = funcionario.nombreCompleto;
              this.nombresVisitante =
                funcionario.primerNombre + " " + funcionario.segundoNombre;
              this.apellidosVisitante =
                funcionario.primerApellido + " " + funcionario.segundoApellido;
              this.visitaModel.numeroDocumentoUsuario =
                funcionario.funcionarioPK.numeroIdFuncionario;
              this.visitaModel.tipoDocumentoUsuario =
                funcionario.funcionarioPK.tipoIdFuncionario;
              this.visitaModel.tipoFuncionario = funcionario.tipoFuncionario;
              this.visitaModel.tipoVisitante =
                DominiosService.DOMINIO_TIPO_VISITANTE;
              this.inhabilitarCampos = true;
              this.disableDatePicker = false;
              this.visitaModel.visitas = [];
              this.spinner.hide();
            } else {
              // this.visitaModel = new AgendaModel('', '', '', '', '', this.visitaModel.visitas);
			  this.inhabilitarCampos = false;
              this.spinner.hide();
            }
            this.fechaConsulta = !this.fechaConsulta
              ? new Date()
              : this.fechaConsulta;
          } else {
			this.inhabilitarCampos = false;
            this.obtenerVisitante(numerodocumento);

            // this.visitaModel.correo = null;
            // this.visitaModel.empresa = null;
            // this.visitaModel.nombreUsuario = null;
            // this.disableDatePicker = false;
            // this.visitaModel.visitas = [];
            // this.spinner.hide();
          }
        },
        (err) => {
          this.cathException("Error al obtener visitante");
          this.disableDatePicker = false;
        }
      );
      this.subscription.push(subscribe);
    }

    if (this.visitaModel.visitas.length < 1) {
      this.agendaMensaje = true;
    } else {
      this.agendaMensaje = false;
    }
  }

  // fromero
  // metodo de redirección a página de consultas
  // 15/05/2019
  regresarListaAgendas() {
    this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] =
      undefined;
    this.router.navigate(["main/"]);
  }

  // fromero
  // método para set el tipo de documento
  // 29/05/2019
  public setDocumento(event) {
    this.visitaModel.tipoDocumentoUsuario = event.target.value;

    if (this.visitaModel.numeroDocumentoUsuario) {
      this.obtenerFuncionario(this.visitaModel.numeroDocumentoUsuario);
    }
  }
  
  public setMotivoIngresoComo(event) {
    this.visitaModel.motivoIngresoComo = event.target.value;
  }
  
  public setRh(event) {
    this.visitaModel.rh = event.target.value;
  }

  // fromero
  // 29/05/2019
  // metodo para validar si se limpia el nombre del funcionario
  public validateInputName(event?) {
    if (!this.editar) {
      if (event === undefined) {
        this.visitaModel = new AgendaModel("", "", "", "", "", []);
      }
    }
  }

  // fromero
  // 05/06/2019
  // Metodo para validar  los campos obligatorios del formulario

  public validarFormulario(boton?) {
	if (boton && (boton == ConstantesService.BTN_NO || boton == ConstantesService.BTN_OTRO)) {
      this.formDisabled = false;
      this.modalOptions.disabled = false;
      this.placaInvalida = false;
    }else {
      if (boton && boton !== ConstantesService.BTN_BICI) {
        if (!this.visitaModel.placa || this.visitaModel.placa === "") {
          this.formDisabled = true;
          this.modalOptions.disabled = true;
          this.placaInvalida = true;
        } else {
          this.formDisabled = false;
          this.modalOptions.disabled = false;
          this.placaInvalida = false;
        }
      } else {
        if (
          document.getElementById(ConstantesService.BTN_CARRO) &&
          document.getElementById(ConstantesService.BTN_MOTO) &&
		  document.getElementById(ConstantesService.BTN_OTRO)
        ) {
          if (
            (document
              .getElementById(ConstantesService.BTN_CARRO)
              .classList.contains("selected") ||
              document
                .getElementById(ConstantesService.BTN_MOTO)
                .classList.contains("selected")) &&
            (!this.visitaModel.placa || !this.visitaModel.tipoVehiculo)
          ) {
            this.placaInvalida = true;
          } else {
            if (this.visitaModel.tipoVehiculo === "BICI") {
              this.placaInvalida = false;
            } else {
              if (!this.visitaModel.placa || !this.visitaModel.tipoVehiculo) {
                this.placaInvalida = false;
              } else {
                if (this.visitaModel.placa !== "") {
                  this.placaInvalida = false;
                } else {
                  this.placaInvalida = true;
                }
              }
            }
          }
        }
      }
    }

    if (this.visitaModel.visitas.length < 1) {
      this.agendaMensaje = true;
    } else {
      this.agendaMensaje = false;
    }

    this.spinner.show();

    if (
      this.nombresVisitante === "" || !this.nombresVisitante ||
      this.apellidosVisitante === "" || !this.apellidosVisitante ||
      this.visitaModel.tipoDocumentoUsuario === "" || !this.visitaModel.tipoDocumentoUsuario ||
      this.visitaModel.numeroDocumentoUsuario === "" || !this.visitaModel.numeroDocumentoUsuario ||
	  
	  this.visitaModel.telefono === "" || !this.visitaModel.telefono ||
	  this.visitaModel.rh === "" || !this.visitaModel.rh ||
	  this.visitaModel.eps === "" || !this.visitaModel.eps ||
	  this.visitaModel.arl === "" || !this.visitaModel.arl ||
	  this.visitaModel.nombreContactoEmergencia === "" || !this.visitaModel.nombreContactoEmergencia ||
	  this.visitaModel.telefonoContactoEmergencia === "" || !this.visitaModel.telefonoContactoEmergencia ||
	  this.visitaModel.alergiasMedicamentos === "" || !this.visitaModel.alergiasMedicamentos ||
      this.correoInvalido || 
	  this.numeroDocumentoInvalido ||
      !this.validarEmpresa() ||
      this.visitaModel.visitas.length < 1 ||
      this.placaInvalida ||
      (this.repetirAgenda &&
        (!this.fechaFinAgenda ||
          this.fechaFinAgenda.getTime() < this.fechaConsulta.getTime()))
    ) {
      if (
        this.repetirAgenda &&
        this.fechaConsulta.getTime() > this.fechaFinAgenda.getTime()
      ) {
        this.alertService.generateAlertError(
          ConstantesService.MSG_AGENDA_FECHAS_MULTIPLE_ERROR,
          "Error"
        );
      }
      this.formDisabled = true;
      this.modalOptions.disabled = true;
      this.spinner.hide();
    } else {
      this.visitaModel.nombreUsuario =
        this.nombresVisitante + " " + this.apellidosVisitante;
      this.validarNombres();
      this.validarApellidos();
      this.formDisabled = false;
      this.modalOptions.disabled = false;
      this.spinner.hide();
    }

    if (
      !this.visitaModel.tipoDocumentoUsuario ||
      !this.visitaModel.numeroDocumentoUsuario ||
      this.visitaModel.numeroDocumentoUsuario === ""
    ) {
      this.disableDatePicker = true;
    }
  }

  /**
   * Válida el campo empresa
   * @returns retorna falso si la selección es empresa y está vacio el cambio devisitaModel.empresa
   */
  validarEmpresa(): boolean {
    if (
      this.visitaModel.tipoVisitante == DominiosService.DOMINIO_TIPO_VISITANTE
    ) {
      return true;
    } else {
      if (
        this.visitaModel.tipoVisita &&
        this.visitaModel.tipoVisita === "Entidad" &&
        this.visitaModel.empresa &&
        this.visitaModel.empresa.length > 2
      ) {
        return !(this.visitaModel.empresa === "" || !this.visitaModel.empresa);
      } else if (this.visitaModel.tipoVisita === "Personal") {
        this.visitaModel.empresa = "";
        return true;
      }
      return false;
    }
  }

  // fromero
  // 05/06/2019
  // metodo para validar correo electrónico
  validarCorreo() {
    const regex =
      /^(([^<>()[\]\.,;:\s@\']+(\.[^<>()[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i;

    if (this.visitaModel.correo !== "" && this.visitaModel.correo) {
      const reps = regex.test(this.visitaModel.correo);
      this.correoInvalido = !reps;
      return reps;
    } else {
      this.correoInvalido = false;
      return true;
    }
  }
  
  validarNumeroDocumento() {
    const regex =
      /^[1-9][0-9]+$/i;

    if (this.visitaModel.numeroDocumentoUsuario !== "" && this.visitaModel.numeroDocumentoUsuario) {
      const reps = regex.test(this.visitaModel.numeroDocumentoUsuario);
      this.numeroDocumentoInvalido = !reps;
      return reps;
    } else {
      this.numeroDocumentoInvalido = false;
      return true;
    }
  }

  ngOnDestroy() {
    this.subscription.forEach((element) => {
      element.unsubscribe();
    });
    this.spinner.hide();
  }

  validarNombres() {
    const nombres = this.utilService.separarString(this.nombresVisitante);

    this.visitaModel.primerNombre = nombres[0];
    this.visitaModel.segundoNombre = nombres[1] ? nombres[1].trim() : "";
  }

  validarApellidos() {
    const apellidos = this.utilService.separarString(this.apellidosVisitante);

    this.visitaModel.primerApellido = apellidos[0];
    this.visitaModel.segundoApellido = apellidos[1] ? apellidos[1].trim() : "";
  }

  actualizarRepeticion(marcado) {
    this.repetirAgenda = marcado;
    if (marcado) {
      if (!this.fechaConsulta) {
        this.repetirAgenda = false;
      } else {
        const fechaM = moment(this.fechaConsulta);
        this.fechaFinAgenda = fechaM.add(1, "day").toDate();
        this.fechaMinFin = fechaM.toDate();
      }
    } else {
      this.fechaFinAgenda = undefined;
      this.fechaMinFin = undefined;
    }
  }
}
